var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuggestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2476 27.0301L24.3402 23.1227C26.1031 20.767 25.9156 17.4026 23.7755 15.2603C21.4285 12.9132 17.6073 12.9132 15.2603 15.2603C12.9132 17.6074 12.9132 21.4286 15.2603 23.7757C16.4349 24.9503 17.9758 25.5365 19.519 25.5365C20.7884 25.5365 22.0578 25.1378 23.1225 24.3404L27.0299 28.2478C27.198 28.4159 27.4178 28.5 27.6398 28.5C27.8596 28.5 28.0816 28.4159 28.2497 28.2478C28.5838 27.9116 28.5838 27.3663 28.2476 27.0301ZM16.478 22.558C14.8034 20.8833 14.8034 18.157 16.478 16.4802C17.3163 15.6418 18.4155 15.2237 19.5168 15.2237C20.6181 15.2237 21.7173 15.6418 22.5557 16.4802C24.2302 18.1548 24.2302 20.8812 22.5557 22.558C20.8811 24.2348 18.1526 24.2326 16.478 22.558Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestion);
export default __webpack_public_path__ + "static/media/suggestion.3cd4456b75186b454563eb02387802a4.svg";
export { ForwardRef as ReactComponent };